module.exports = __webpack_public_path__ + "static/natalia-flores-800e3b389a2db0242f12321de13a5269.jpeg";